import { humidityLvlColor } from '@/modules/common/utils/get-humidity-color';
import { Humidity } from '@/shared/ui/icons';
import classNames from 'classnames';
import styles from './index.module.sass';
import strucIcon from '@@/mixing/components/recipes-detail/icons/struc.svg';
import tempIcon from '@@/mixing/components/recipes-detail/icons/temp.svg';
import {
  BestPriceBuyerItem,
  IBestPriceBagItem,
} from '@/modules/mixing/store/analytical-mixing.store';
import ResponsiveSvgComponent from '@/shared/ui/responsive-wheat-heap';
import { useWindowDimensions } from '@/modules/common/hooks/use-window-dimensions.hook';

export const WheatInfo = ({
  data,
  offer,
  className,
  isStationary,
}: {
  data: IBestPriceBagItem;
  offer?: BestPriceBuyerItem;
  className?: string;
  isStationary?: boolean;
}) => {
  const { width } = useWindowDimensions();
  return (
    <div className={isStationary && width > 2230 ? classNames(styles.wheatHeapInfo, className) : classNames(styles.wheatInfo, isStationary && styles.heap, className)}>
      {isStationary && width > 2230 && <ResponsiveSvgComponent/>}

      <div className={isStationary && styles.infoText}>
      <span className={styles.classInfo}>
        {data.agriculture}
        {data.values.class
          ? +data.values.class === 0
            ? ', фураж '
            : `, ${data.values.class}-й класс `
          : ' '}
      </span>
      <span className={styles.typeInfo}>{offer?.type}</span>
      <div className={styles.params}>
        <span className={styles.param}>
          <Humidity fill={humidityLvlColor(+data.values.humidity)} />{' '}
          {data.values.humidity ?? '- '}%
        </span>
        <span className={styles.param}>
          <img src={strucIcon} className={styles.icon} /> {data.values.gluten ?? '- '}%
        </span>
        <span className={styles.param}>
          <img src={tempIcon} className={styles.icon} />{' '}
          {data.values.temperature ?? '- '}°C
        </span>
          </div>
      </div>
    </div>
  );
};
